// @flow

module.exports = {
  colors: require('./colors'),
  viewports: {
    mobile: 'max-width: 879px',
    desktop: 'min-width: 880px',
    retina: '(-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi)',
  },
  fonts: {
    default:
      '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif',
  },
  fontWeights: {
    light: '200',
    normal: '400',
    medium: '500',
    semibold: '600',
  },
  // Used for styled-system
  breakpoints: ['880px'],
  boxShadows: {
    default: '0 1px 3px 0 rgba(35, 43, 51, 0.16)',
    input: {
      default: 'inset 0 1px 3px rgba(197, 206, 214, 0.16)',
      focused: 'inset 0 1px 3px 0 rgba(64, 156, 249, 0.16)',
      error: '0 0 3px 0 rgba(225, 78, 56, 0.24)',
    },
    select: {
      default: '0px 4px 12px rgba(34, 45, 56, 0.08), 0px 0px 1px rgba(34, 45, 56, 0.08)',
    },
    button: {
      focused: '0 0px 0px 3px rgba(64, 156, 249, .4)',
    },
  },
  //      0  1  2   3   4   5   6   7   8   9   10
  space: [0, 8, 12, 16, 20, 24, 32, 48, 64, 80, 100],
};
